interface VeracordLogoProps {
  size?: 'sm' | 'md' | 'lg';
  color?: string;
}

export const VeracordLogo = ({ size = 'md', color = '#ffffff' }: VeracordLogoProps) => {
  const sizes = { sm: '20px', md: '28px', lg: '36px' };

  return (
    <span style={{
      fontFamily: 'Source Serif Pro, Georgia, serif',
      fontWeight: 900,
      fontSize: sizes[size],
      color,
      letterSpacing: '-0.01em',
      lineHeight: 1,
      display: 'inline-flex',
      alignItems: 'flex-start',
    }}>
      Veracord
      <span style={{
        fontSize: '9px',
        fontWeight: 400,
        position: 'relative',
        top: '-1px',
        marginLeft: '2px',
        fontFamily: 'Inter, sans-serif',
      }}>™</span>
    </span>
  );
};

export default VeracordLogo;
